if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {
	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)

	// validation if missing top content
	const top_Content = document.querySelector("#top-content");
	if(top_Content == null){
		document.querySelector("#header").classList.add("not-topcontent")
	}

	// burger menu funcionality
	const burgerMenu = document.querySelector('.js-burger-menu')
	const ctaBurger = document.querySelectorAll('.js-cta-buger')
	const ctaBurgertext = document.querySelectorAll('.js-cta-buger .text')

	//Open Menu
	function toggleMenu() {
		burgerMenu.classList.toggle('open');
		document.body.classList.toggle('no-scroll');
		document.querySelector('#header').classList.toggle('menu-open');
	
		const isMenuOpen = document.querySelector('#header').classList.contains('menu-open');
		ctaBurgertext.forEach((cta) => {
			cta.innerText = isMenuOpen ? 'close' : 'menu';
		});
	}
	
	ctaBurger.forEach((cta) => {
		cta.addEventListener('click', (e) => {
			e.preventDefault();
			toggleMenu();
		});
	});
	
	//CTA funcionality
	const cta_span = document.querySelectorAll(".btn");

	cta_span.forEach( cta => {
		let label_Cta = `<span class="label-cta">${cta.textContent}</span>`;
		cta.innerHTML = label_Cta;
	});

	// slick default setting
	let defaulsettings = {
		loop: true,
		speed: 700,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		navigation: {
			nextEl: '.swiper-prev',
			prevEl: '.swiper-next',
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
	}

	// start slider default
	let allSwipper = []

	document.querySelectorAll('.swiper-js').forEach((element, i) => {
		let swiperConfig = element.dataset.swiper
			? JSON.parse(element.dataset.swiper)
			: defaulsettings

		element.setAttribute(`data-swiper-${i}`, '')

		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig)

		allSwipper[i] = swiper
	})

	document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0;
		const slider = item.dataset.swipertarget ? document.querySelector(item.dataset.swipertarget) : item.closest('.swiper-js');
		item.addEventListener('mouseover', () => {
			slider.swiper.slideTo(target);
			document.querySelectorAll('[data-swiper-goto]').forEach((itm) => itm.classList.remove('active'));
			item.classList.add('active');
		});
	});

	 //custom swiper controller
	 allSwipper.forEach((swiper) => {
		const customControl = swiper.passedParams.customcontrol;
		if (customControl) {
				const targetIds = customControl.substr(1).split(" ");
				const targetSwipers = allSwipper.filter((s) => targetIds.includes(s.el.id));
				if (targetSwipers.length > 0) {
						swiper.controller.control = targetSwipers;
						//TODO: more the two swiper
						// targetSwipers.forEach((targetSwiper) => { 
						//     console.log(targetSwiper.controller);
						//     targetSwiper.controller.control = [...new Set([swiper, ...targetSwiper.controller.control || []])];
						// });
				}
			}
	});

	//Pin Map
	
	if (document.querySelector('.location') != null) {
		const all_Pins = document.querySelectorAll('[data-isla]')
		const all_Lightboxs = document.querySelectorAll('[data-lightbox]')
		const close_Ctas = document.querySelectorAll('.location-close-js')
		const all_Isname = document.querySelectorAll('[data-name]')

		all_Pins.forEach((pin) => {
			pin.addEventListener('click', (e) => {
				all_Pins.forEach((removeisl) => removeisl.classList.remove('active'))
				pin.classList.add('active')

				all_Lightboxs.forEach((lightbox) => {
					lightbox.classList.remove('active')
					if (lightbox.dataset.lightbox == pin.dataset.isla) {
						lightbox.classList.add('active')
					}
				})
			})
		})
		
		close_Ctas.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				e.preventDefault()
				all_Pins.forEach((removeisl) => removeisl.classList.remove('active'))
				all_Lightboxs.forEach((removeisl) =>
					removeisl.classList.remove('active'),
				)
			})
		})

		all_Isname.forEach((isl_Name) => {
			let rect_sizes = isl_Name.getBoundingClientRect()
			let rect_width = parseFloat(rect_sizes.width) + 10
			let rect_height = parseFloat(rect_sizes.height) + 10

			let fisrtletter_Pos = isl_Name.querySelector('g .cls-3')
			if (fisrtletter_Pos != null) {
				let pos_Box = fisrtletter_Pos.getAttribute('d')
				let regex = /[MLHVCSQTAZmlhvcsqtaz][^MLHVCSQTAZmlhvcsqtaz]*/g
				let commands = pos_Box.match(regex)
				let fisrt_Element = commands.shift().substring(1)
				let values = fisrt_Element.split(',')
				let x = parseFloat(values[0]) - 10
				let y = parseFloat(values[1]) - 10

				let rect_intro = `<rect width="${rect_width}" height="${rect_height}" fill="transparent" x="${x}" y="${y}"/>`
				isl_Name.insertAdjacentHTML('afterbegin', rect_intro)
			}
		})
	}

	
	//Home tabs accordion funcionality
	let acordionitems = document.querySelectorAll(".accordion-js .tab-js")
	acordionitems.forEach((item) => {
		item.addEventListener('click',  function(element) {
			acordionitems.forEach(removeactive => {
				removeactive.classList.remove('active');
				removeactive.nextElementSibling.classList.remove('active');
			});
			
			this.classList.toggle('active');
			this.nextElementSibling.classList.toggle('active');
		})
	})

	// Big accordion funcionality
	let bigacordionitems = document.querySelectorAll(".big-accordion-js");
	bigacordionitems.forEach(currentItem => {
		if (window.innerWidth > 600) {

			["mouseenter","mouseleave","touchend"].forEach(currentEvent => {
				currentItem.addEventListener(currentEvent, function(e)  {
					this.classList.toggle('active');
					this.firstElementChild.classList.toggle('active')
				});
			});
			
		} else {
			currentItem.addEventListener('click',  function(event) {
				if (!this.classList.contains('active')) {
					bigacordionitems.forEach(remove => remove.classList.remove("active"));
					this.classList.add('active');
				} else {
					this.classList.remove('active');
				}
			});
		}
	});

	let quadReviews = new Swiper('.reviews__slider',{
		loop: true,
		speed: 700,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		navigation: {
			prevEl: '.reviews-prev',
			nextEl: '.reviews-next'
		}
	});


	//For FAQ

	document.querySelectorAll('[data-filter]').forEach((btn, i) => {
		btn.addEventListener('click', e => {
			e.preventDefault()
				document.querySelectorAll('[data-filter]').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('[data-section]').forEach(section => {
					section.classList.remove('active');
						if (btn.dataset.filter === section.dataset.section ) {
							section.classList.add('active');
						}
				});
		});

		if (i === 0) btn.click()
	});

	const select_faq = document.querySelector('#select-faq');
	if (select_faq != null) {
		select_faq.addEventListener('change', e => {
			document.querySelectorAll('[data-section]').forEach(seccion => {
				seccion.classList.remove('active');
				if (select_faq.value === seccion.dataset.section) {
					seccion.classList.add('active');
				}
			});
		});
	}

	//accordion Funcionality
	let normal_accordion = document.querySelectorAll("[data-accodion] .tab-js");
	normal_accordion.forEach( item => {
		item.addEventListener("click", (element) => {
			element.target.classList.toggle("active");
			element.target.nextElementSibling.classList.toggle("active");
		});
	});

	// LBX class overflow
	LBX._instances.forEach(currentItem => {
		currentItem.beforeShow = () => document.querySelector("body").classList.add("no-scroll")
		currentItem.beforeClose = () => document.querySelector("body").classList.remove("no-scroll");
	});
	


	// Form 
	const form = document.querySelector(".form-module-wrapper");
	if (form) {
		const element_Wrap = document.querySelector(".gdpr-wrap");
		const element_appet = document.querySelector(".form-module__submit");
		element_Wrap.insertAdjacentElement('beforeend', element_appet);
	}

	const wrap_Fielset = document.querySelectorAll(".form-module-wrapper fieldset")
	if (wrap_Fielset) {
		// add wrapper for accordion
		wrap_Fielset.forEach( group => {

			let wrap_Div = document.createElement("div")
			wrap_Div.classList.add("form-module__wrap")
			let all_Children = [...group.children];
			all_Children.forEach(currentItem => {
				if (currentItem.tagName.toLocaleLowerCase() !== "legend") {
					wrap_Div.appendChild(currentItem,wrap_Div)
				}
			});
			group.appendChild(wrap_Div);
		});

		const accordion_Fielset = document.querySelectorAll(".form-module-wrapper fieldset legend");
		// add funcionality for accordion
		accordion_Fielset.forEach(tab => {
			//start open
			tab.classList.add("active");
			tab.nextElementSibling.classList.add("active");

			tab.addEventListener('click', element => {
				element.target.classList.toggle("active");
				element.target.nextElementSibling.classList.toggle("active");
			})
		});
	}
	const label_file = document.querySelectorAll(".form-module .form-module__field.fileupload label:first-child");
	if (label_file) {		
		label_file.forEach(input => {
			if (input.classList.contains("hidden")) {
				input.classList.remove("hidden")
			}
		})
	}
	// for input label in mobile
 if (window.innerWidth <= 767) {
	let dateInputs = document.querySelectorAll('input[type="date"], input[type="time"]');
	dateInputs.forEach(function(input) {
		input.addEventListener('input', function() {
			if (input.value.length > 0) {
				input.classList.add('full');
			} else {
				input.classList.remove('full');
			}
		});
	});
}

})()
